import {  Button, ButtonGroup } from "@mui/material";
import React, { useState } from "react";
import DatatableComponent from "helpers/DatatableComponent";
import { useHistory } from "react-router-dom";
import StatusLayout from "components/Status";
import moment from "moment";
import BasicMenu from "../../helpers/menu";
import WorklogManager from "../../views/admin/WorklogManager";
import {DonutLarge} from "@material-ui/icons";

const TrackingListComponent = (props) => {
  const {
    GetAllMeetings,
    location,
    notification,
    MarkAsRead,
    refresh,
  } = props;
  const [selected, setSelected] = useState(location?.state?.status ?? "All");
  const [logOpen, setLogOpen] = React.useState(false);
  const [id, setId] = useState(null);
  const [list,setList]=useState([])
let history = useHistory();
const columns = [
  {
    label: "Name",
    name: "name",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Start Date",
    name: "startDate",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (v) => moment(v).format("DD/MM/yyyy")
    },
  },
  {
    label: "End Date",
    name: "endDate",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (v) => moment(v).format("DD/MM/yyyy")
    },
  },
  {
    label: "Responsible",
    name: "responsible.names",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    label: "Report To",
    name: "report.names",
    options: {
      filter: true,
      sort: true,
    },
  },

  {
    label: "Status",
    name: "status",
    options: {
      filter: true,
      sort: true,
      customBodyRender: (status) =>(<StatusLayout status={status}/>)
    },
  },
  {
    name: "id",
    label: "Action",
    options: {
      filter: true,
      sort: false,
      customBodyRender: (id) => {
        let detail =
          notification?.filter((notif) => notif?.content?.id === id && notif?.content?.type === "meetingAction") ??
          [];
        return <BasicMenu extra={[
              {
                onClick:() => {
                  if (detail && detail[0]?.id) {
                    MarkAsRead(detail[0]?.id);
                  }
                  history.push(`/admin/action/details/${id}`);
                },
                label:<span>Details{" "}{detail[0]?.content?.id === id ? (
                    <span className="badge bg-green-400 rounded-pill ">
                {"NEW"}
              </span>
                ) : null}</span>
              },
          {
            onClick:()=>{
              setId(id);
              setLogOpen(true);
            },
            label:"Worklogs",
            icon:<DonutLarge />
          }
            ]}/>
      },
    },
  },
];


  return (
    <div className="">

      <WorklogManager actionTrackId={id} open={logOpen} setOpen={()=>setLogOpen(false)}/>
          <DatatableComponent
        title={
          <ButtonGroup
            variant="outlined"
            color={"success"}
            size={"small"}
            aria-label="outlined button group">
            {["all", "not yet started", "in progress", "on hold","completed","overdue"].map((title, key) => (
              <Button
                key={key}
                type="button"
                style={{
                  backgroundColor:
                    selected === title ? "green" : "",
                  color:
                    selected === title
                      ? "white"
                      : "green",
                }}
                onClick={() => {
                  setSelected(title);
                  GetAllMeetings(title);
                }}>
                {title}
              </Button>
            ))}
          </ButtonGroup>
        }
        processData={(data) => {
          setList(data.data);
          return data;
        }}
        columns={columns}
        url={`/api/meeting-action/datatable/?status=${selected}&refresh=${refresh??''}`}
        useMeetingUrl={true}
        onRowClick={(data, { rowIndex }) => {
          let detail =
          notification?.filter((notif) => notif?.content?.id === list[rowIndex].id && notif?.content?.type === "meetingAction") ??
          [];
          if (detail && detail[0]?.id) {
            MarkAsRead(detail[0]?.id);
          }
          history.push(`/admin/action/details/${list[rowIndex].id}`); 
        }}
   
      />
    </div>
  );
};
export default TrackingListComponent;
